import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Shield } from "lucide-react";

export default function Navbar() {
  const navItem = ({ isActive }) =>
    `px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] border-2 ${
      isActive ? "bg-black text-white border-black" : "bg-white text-black border-black hover:bg-black hover:text-white"
    } transition-colors`;
  const [isAdmin, setIsAdmin] = useState(
    () => typeof window !== "undefined" && !!sessionStorage.getItem("wg_admin_token")
  );
  useEffect(() => {
    const onChange = () => setIsAdmin(!!sessionStorage.getItem("wg_admin_token"));
    window.addEventListener("wg-admin-changed", onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener("wg-admin-changed", onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);

  return (
    <header className="border-b-2 border-black bg-white sticky top-0 z-40" data-testid="site-navbar">
      <div className="tape" />
      <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <div className="w-9 h-9 bg-black text-white flex items-center justify-center">
            <Shield size={18} strokeWidth={2.5} />
          </div>
          <div>
            <div className="text-lg font-black tracking-tighter uppercase leading-none" style={{ fontFamily: "'Clash Display'" }}>WallGard</div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500">URL Threat Intelligence</div>
          </div>
        </Link>
        <nav className="flex items-center gap-2">
          <NavLink to="/" end className={navItem} data-testid="nav-home">Home</NavLink>
          <NavLink to="/my" className={navItem} data-testid="nav-my">My Scans</NavLink>
          <NavLink to="/install" className={navItem} data-testid="nav-install">Install</NavLink>
          <NavLink to="/dashboard" className={navItem} data-testid="nav-dashboard">Admin Dashboard</NavLink>
          <NavLink to="/settings" className={navItem} data-testid="nav-settings">{isAdmin ? "Admin" : "Admin Login"}</NavLink>
        </nav>
      </div>
    </header>
  );
}
